var SearchCardTypes = /* @__PURE__ */ ((SearchCardTypes2) => {
  SearchCardTypes2["BonusAndEconomicContributions"] = "bonusAndEconomicContributions";
  SearchCardTypes2["DeductionsAndFiscalBonus"] = "deductionsAndFiscalBonus";
  SearchCardTypes2["FiscalDeclarationAnd730"] = "fiscalDeclarationAnd730";
  SearchCardTypes2["CertificatesAndSupportServices"] = "certificatesAndSupportServices";
  SearchCardTypes2["FinancialServices"] = "financialServices";
  SearchCardTypes2["Other"] = "other";
  return SearchCardTypes2;
})(SearchCardTypes || {});
export {
  SearchCardTypes
};
//# sourceMappingURL=search-card.interface.es.js.map
